module.exports = __webpack_public_path__ + "assets/f9c87f4441d6924bcefe4ab97522efbe.mp3";